import { apiSlice } from "@/redux/apiSlice";
import { ApiResponse, Category, CategoryTable } from "@/types";

export const categoryApi = apiSlice.injectEndpoints({
    endpoints(builder) {
        return {
            getCategories: builder.query<CategoryTable, { org_id: number; query?: string }>({
                query: ({ org_id, query }) => ({
                    url: `/category?org_id=${org_id}${query ? `&${query}` : ""}`,
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    },
                }),
                providesTags: ["ProductCategory", "FacilityCategory", "Product", "Facility"],
            }),
            getCategoryById: builder.query<Category, { id: number; org_id: number; query?: string }>({
                query: ({ id, org_id, query }) => ({
                    url: `/category/${id}?org_id=${org_id}${query ? `&${query}` : ""}`,
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    },
                }),
                providesTags: ["ProductCategory", "FacilityCategory", "Product", "Facility"],
            }),
            createCategory: builder.mutation<ApiResponse, Partial<Category>>({
                query: (data) => ({
                    url: `/category`,
                    method: "POST",
                    body: data,
                    headers: {
                        Accept: "application/json",
                    },
                }),
                invalidatesTags: ["ProductCategory", "FacilityCategory", "Product", "Facility"],
            }),
            updateCategory: builder.mutation<ApiResponse, Partial<Category> & { id: number }>({
                query: ({ id, ...data }) => ({
                    url: `/category/${id}`,
                    method: "PUT",
                    body: data,
                    headers: {
                        Accept: "application/json",
                    },
                }),
                invalidatesTags: ["ProductCategory", "FacilityCategory", "Product", "Facility"],
            }),
            deleteCategory: builder.mutation<ApiResponse, number>({
                query: (id) => ({
                    url: `/category/${id}`,
                    method: "DELETE",
                    headers: {
                        Accept: "application/json",
                    },
                }),
                invalidatesTags: ["ProductCategory", "FacilityCategory", "Product", "Facility"],
            }),
        };
    },
});

export const {
    useGetCategoriesQuery,
    useGetCategoryByIdQuery,
    useCreateCategoryMutation,
    useUpdateCategoryMutation,
    useDeleteCategoryMutation,
} = categoryApi;
